import request from '../helpers/request';

const updateRequestService = async (requestId, serviceId) => {
  return await request.put(
    `/Request/set_service/${requestId}`,
    serviceId,
    'Не удалось изменить причину'
  );
};

export default updateRequestService;
